/// <reference path="../typings/browser.d.ts" />

import { LoginApi, emptyRequest } from '@deltasierra/shared';
import { IHttpService } from 'angular';
import { $httpSID, $locationSID, ILifecycleHooks } from '../common/angularData';
import { invokeApiRoute } from '../common/httpUtils';
import { InteractionUtils } from '../common/interactionUtils';
import { MvNotifier } from '../common/mvNotifier';
import { I18nService } from '../i18n/i18nService';
import { MvAuth } from './mvAuth';

export class MvForgotPasswordCtrl implements ILifecycleHooks {
    static SID = 'MvForgotPasswordCtrl';

    static readonly $inject: string[] = [
        $httpSID,
        $locationSID,
        MvNotifier.SID,
        MvAuth.SID,
        InteractionUtils.SID,
        I18nService.SID,
    ];

    readonly requestPasswordReset = this.interactionUtils.createFuture(
        () => this.i18n.text.login.requestPasswordReset(),
        () =>
            this.mvAuth.requestPasswordReset(this.username).then(
                () => {
                    this.$location.url('/login');
                    this.notifier.notify(this.i18n.text.login.youWillReceivePasswordResetInstructionsShortly());
                },
                err => this.notifier.unexpectedError(this.i18n.text.login.errorSendingPasswordResetInstructions()),
            ),
    );

    username = '';

    constructor(
        private readonly $http: IHttpService,
        private readonly $location: ng.ILocationService,
        private readonly notifier: MvNotifier,
        private readonly mvAuth: MvAuth,
        private readonly interactionUtils: InteractionUtils,
        private readonly i18n: I18nService,
    ) {
        if (typeof this.$onInit === 'function') {
            // Call $onInit manually if defined
            this.$onInit();
        }
    }

    public async $onInit(): Promise<void> {
        const response = await invokeApiRoute(this.$http, LoginApi.getLoginMethod, emptyRequest());
        if (response && response.isV2AppAuthEnabled && response.appFrontendUrl) {
            window.location.replace(`${response.appFrontendUrl}/forgotPassword`);
        }
    }
}

angular.module('app').controller(MvForgotPasswordCtrl.SID, MvForgotPasswordCtrl);
